import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";

function NotFound() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    // countdown timer
    const interval = setInterval(() => {
      setCountdown((c) => c - 1);
    }, 1000);

    // redirect timer
    const timeout = setTimeout(() => {
      navigate("/", { replace: true });
    }, 5000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [navigate]);

  return (
    <div style={{ padding: "4rem", textAlign: "center" }}>
      <h1>404 – Page Not Found</h1>
      <p>The page you’re looking for doesn’t exist.</p>

      <p>
        Redirecting to home in <strong>{countdown}</strong> seconds…
      </p>

      <Link to="/">Go home now</Link>
    </div>
  );
}

export default NotFound;